import { render, staticRenderFns } from "./SpecialTag.vue?vue&type=template&id=5e0014ce&scoped=true&"
import script from "./SpecialTag.vue?vue&type=script&lang=js&"
export * from "./SpecialTag.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTag.vue?vue&type=style&index=0&id=5e0014ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0014ce",
  null
  
)

export default component.exports